import DriveChart from "../components/DriveChart"


export default function DrivePage({user})
{
  return(
<div className="App" id="main-bg">
    <main>
    <section id="core-concepts">
        <h2>Driving</h2>
        <menu id='flexbox-row'>
        From: <input className="tab-button"/>
        To: <input className="tab-button"/>
        </menu>
      </section>
    </main>

     <DriveChart user={user}/>

     <main>

</main>

  </div>
  )
}


